/*! aem-component-data-util 1.0.0 */
import{useSSRContext as n}from"vue";function o(o){if(!("undefined"!=typeof window))return{payload:n()?.AEMContext?.payload,config:n()?.AEMContext?.config};return(window.top||window).aemNamespace.componentData[o]}export{o as getComponentData};
//# sourceMappingURL=index.js.map
